<div class="column custom-form__block" :class="columnWidthClass">
    <b-field :label="field.label" :message="fieldMessage" :type="fieldType" label-position="inside">
        <b-input type="textarea" :name="field.name" :placeholder="field.placeholder" :required="field.required" :modelValue="modelValue" @update:modelValue="onInput" />
    </b-field>
</div>
